<div class="loading-bar top" *ngIf="lb.percent && lb.percent <= 100" [style.width]="lb.percent + '%'" [class.desvaness]="lb.percent === 100"></div>
<router-outlet></router-outlet>